export default __webpack_public_path__ + "static/media/nikeshoes.172eb56d.jpg";